
import React from 'react';

const Dropdown = (props) => {

  const renderOptionsElements = (options) => props.isObject ?
    options.map((val) => <option key={val.key} value={val.key}>{val.value}</option>) :
    options.map((val) => <option key={val} value={val}>{val}</option>);

    const { options, onChange, className, value, defaultOption, defaultValue, defaultHidden } = props;
    return (
      <select className={className || ''} onChange={onChange} value={value}>
        {defaultOption && <option value={defaultValue || ''} disabled hidden={defaultHidden}>{defaultOption}</option>}
        {renderOptionsElements(options)}
      </select>
    );
}

export default Dropdown;